import React, { useState, useEffect } from "react";
import articleImgOne from "../../../../assets/images/articleImgOne.png";
import SearchBtnGroup from "../../../../components/CommonCompnents/resourcePage/SearchBtnGroup";
import Footer from "../../Footer";
import ArticleBanner from "../../../../components/CommonCompnents/resourcePage/ArticleBanner";
import { getArticleById } from "../../../../services/Faqs&Resourse/resource";
import myAppsUrlConfig from "../../../../config/MyApp/myAppsURLConfig";
const ArticleDetailOne = (props) => {
  const id = props.match.params.resourceId;

  const [article, setArticle] = useState("");

  const getResoucesRes = (res) => {
    if (res && res.data) {
      setArticle(res.data);
    }
  };

  useEffect(() => {
    getArticleById(getResoucesRes, id);
  }, []);

  return (
    <div>
      <div className="container">
        <div className="articleDetail-container">
          <div className="back_btn">
            <i class="edel-icon-arrow-left"></i>
            <span onClick={() => props.history.goBack()}>Back</span>
          </div>
          <div className="artical_details_pages">
            <div className="artical_page">
              <ArticleBanner
                img={
                  article.imagepath?.includes(myAppsUrlConfig.appIcon)
                    ? article.imagepath
                    : myAppsUrlConfig.appIcon + article.imagepath
                }
                article={{
                  headTitle: article.name,
                  articalId: article.resourceId,
                  date: article.date,
                }}
              />
              {article.emtDescription ? (
                <div
                  className="artical_page_content"
                  dangerouslySetInnerHTML={{ __html: article.emtDescription }}
                ></div>
              ) : (
                ""
              )}

              {/* <div className="nextArtcalBtn">
                <span>
                  Read next artical <i className="edel-icon-arrow-right"></i>
                </span>
              </div> */}
              <div className="tradingAlgos">
                {/* <h4>Recommended Articles</h4>
                <div className="article_section_wrap">
                  <Artical title="How Do I Trade With APIs?" articalId="2" />

                  <Artical title="What is an API?" articalId="3" />
                </div> */}
              </div>
              <div>
                {/* <div className="resouces_btn_section align_left">
                  <p>Search for topics related to</p>
                  <SearchBtnGroup />
                </div> */}
              </div>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default ArticleDetailOne;
